class CarFinderNavigationItem {
    constructor(el, index) {
        this.render(el, index);
    }

    handleClick(event){
        event.preventDefault();
        const el = $(this);
        const action = el.attr('data-action');
        el.trigger(action);
    }

    render (el) {
        this.el = $(el);
        this.buttons = this.el.find('*[data-component="c-car-finder-nav-button"]');
        this.buttons.on('click', this.handleClick);
    }
}

class CarFinderNavigation {
    constructor(selector) {
        this.all = document.querySelectorAll(selector);
        for ( var i = 0; i < this.all.length; i++ ) {
            this.render(this.all[i], i);
        }
    }

    render (el, index) {
        new CarFinderNavigationItem(el, index);
    }
}

export default CarFinderNavigation;
new CarFinderNavigation('*[data-component="c-car-finder-nav"]');